import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "", stack: "" };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: (error && error.message) || String(error),
      stack: (error && error.stack) || "",
    };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
    this.setState({
      message: (error && error.message) || String(error),
      stack: ((error && error.stack) || "") + "\n\n" + ((info && info.componentStack) || ""),
    });
  }
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="flex flex-col items-center justify-center text-center py-12 px-4">
          <div className="w-14 h-14 rounded-2xl bg-red-500/15 flex items-center justify-center mb-4">
            <AlertTriangle className="w-7 h-7 text-red-400" />
          </div>
          <h2 className="text-lg font-semibold text-slate-100 mb-1">Algo deu errado ao carregar esta seção</h2>
          <p data-testid="error-boundary-message" className="text-sm text-red-300 mb-3 max-w-md break-words font-mono">
            {this.state.message}
          </p>
          {this.state.stack && (
            <pre data-testid="error-boundary-stack" className="text-[10px] text-slate-500 mb-5 max-w-full max-h-48 overflow-auto text-left whitespace-pre-wrap break-words bg-[#0F1520] border border-[#263147] rounded-lg p-3">
              {this.state.stack}
            </pre>
          )}
          <Button data-testid="error-boundary-reload" onClick={() => window.location.reload()}
            className="bg-emerald-500 hover:bg-emerald-600 text-[#0A0D12] font-semibold rounded-xl">
            Recarregar
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
